import { useState } from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { useFormik } from 'formik'
import { forgotPassword, recoverPassword, requestPassword } from '../core/_requests'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'

const initialValues = {
    login: '',
}
const maskEmail = (email: string) => {
    const [name, domain] = email.split("@");
    if (!name || !domain) return email;

    const maskedName = name.substring(0, 3) + "***";
    const maskedDomain = "***" + domain.slice(-4);

    return `${maskedName}@${maskedDomain}`;
};


const forgotPasswordSchema = Yup.object().shape({
    login: Yup.string()
        .min(3, 'Campo muito curto')
        .max(50, 'Campo muito longo')
        .required('Preencha com seu login'),
})

export function ForgotPassword() {
    const [redirectCountdown, setRedirectCountdown] = useState(5);
    const [successMessage, setSuccessMessage] = useState("");
    const [loading, setLoading] = useState(false)
    const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined)
    const formik = useFormik({
        initialValues,
        validationSchema: forgotPasswordSchema,
        onSubmit: async (values, { setStatus, setSubmitting, setErrors }) => {
            try {
                console.log("🚀 ~ ForgotPassword ~ values:", values);
                const resp: any = await forgotPassword(values.login);
                console.log("🚀 ~ ForgotPassword ~ resp:", resp);
                setEmail(resp.data.email);

                setSuccessMessage("E-mail enviado!");
                let counter = 5;
                const countdownInterval = setInterval(() => {
                    counter -= 1;
                    setRedirectCountdown(counter);
                    if (counter === 0) {
                        clearInterval(countdownInterval);
                        window.history.back();
                    }
                }, 1000);
            } catch (error: any) {
                if (error.response && error.response.status === 400) {
                    setErrors({ login: error.response.data.message });
                } else {
                    setStatus("Ocorreu um erro inesperado. Tente novamente.");
                }
                setSubmitting(false);
            }
        },

    })
    const [email, setEmail] = useState<string | null>(null)

    return (

        <form
            className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
            noValidate
            id='kt_login_password_reset_form'
            onSubmit={formik.handleSubmit}
        >

            <div className='text-center'>
                <img src={toAbsoluteUrl('/media/assemp/assemp-logo-2.svg')} style={{ mixBlendMode: 'multiply' }} className='logo' />
            </div>
            <div className='text-center headline'>
                <h1 className='mb-0'>
                    Esqueceu a senha?
                </h1>
                <p>
                    Insira seu login para iniciar a recuperação de senha.
                </p>
            </div>


            {/* begin::Title */}
            {hasErrors === true && (
                <div className='mb-lg-15 alert alert-danger'>
                    <div className='alert-text font-weight-bold'>
                        Desculpe, ocorreu um erro inesperado. Tente novamente
                    </div>
                </div>
            )}

            {hasErrors === false && (
                <div className='mb-10 bg-light-info p-8 rounded'>
                    <div className='text-info'>E-mail de recuperação de senha enviado.</div>
                </div>
            )}
            {/* end::Title */}

            {/* begin::Form group */}
            <div className='fv-row mb-8'>
                <label className='form-label text-gray-900 fs-6'>Login</label>
                <input
                    type='text'
                    placeholder=''
                    autoComplete='off'
                    {...formik.getFieldProps('login')}
                    className={clsx(
                        'form-control bg-transparent',
                        { 'is-invalid': formik.touched.login && formik.errors.login },
                        {
                            'is-valid': formik.touched.login && !formik.errors.login,
                        }
                    )}
                />
                {formik.touched.login && formik.errors.login && (
                    <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>
                            <span role='alert'>{formik.errors.login}</span>
                        </div>
                    </div>
                )}
            </div>
            {/* end::Form group */}

            {/* begin::Form group */}
            <div className='d-grid  '>
                <button type='submit' id='kt_password_reset_submit' className='btn btn-primary mb-5' disabled={email != null}>
                    <span className='indicator-label'>Solicitar nova senha</span>
                    {loading && (
                        <span className='indicator-progress'>
                            Carregando...
                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                    )}
                </button>

            </div>
            <div className='d-flex text-center justify-content-center'>
                <Link to='/auth/login' className='link-primary'>

                    {email ? 'Voltar' : 'Voltar e fazer login'}
                </Link>{' '}
            </div>

            {successMessage && (
                <div className='alert alert-success mt-4 text-center'>
                    <p>{successMessage}</p>
                    <p>Você será redirecionado em <b>{redirectCountdown}</b> segundos...</p>
                    <p>Se não for redirecionado, <a href="#" onClick={() => window.history.back()}>clique aqui para voltar</a>.</p>
                </div>
            )}

            {
                email ? (
                    <div className='d-flex flex-wrap justify-content-center p-5'>
                        <p>Um e-mail será enviado para <u>{maskEmail(email)}</u></p>
                    </div>
                ) : (<></>)
            }
            {/* end::Form group */}
        </form>
    )
}
